import { ResponsivePie } from '@nivo/pie';
import { useTranslation } from 'react-i18next';

const SvgIcon = ({ centerX, centerY }: { centerX: number; centerY: number }) => (
	<svg
		width='23'
		height='20'
		viewBox='0 0 23 20'
		x={centerX - 11.5} // Adjust to half of the width of the SVG
		y={centerY - 10} // Adjust to half of the height of the SVG
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			fill-rule='evenodd'
			clip-rule='evenodd'
			d='M22.5453 0.993507C22.5778 0.843026 22.4353 0.713744 22.2887 0.760799L18.8254 1.87248C18.6788 1.91954 18.6381 2.10764 18.7522 2.21106L21.4466 4.65449C21.5606 4.75792 21.7438 4.6991 21.7764 4.54862L22.5453 0.993507ZM7.46296 15.1415C8.27549 14.7594 8.56654 13.8946 8.70566 13.1854C8.82645 12.5696 8.87271 11.8364 8.91667 11.1397C8.92579 10.9951 8.93481 10.8521 8.94438 10.7121C9.00293 9.85503 9.08235 9.0722 9.28307 8.43918C9.48052 7.81645 9.76033 7.44726 10.1499 7.26406C10.5558 7.07323 11.0022 7.08958 11.562 7.30198C12.1411 7.52174 12.7485 7.91605 13.4212 8.37353L13.6021 8.49686C14.1925 8.90005 14.8397 9.34194 15.4705 9.62663C16.1744 9.94434 17.0208 10.1425 17.8589 9.74837C18.9975 9.21298 19.4045 8.24522 19.6749 7.54366C19.6975 7.48492 19.7189 7.42899 19.7392 7.37556C19.8498 7.08569 19.9323 6.86965 20.0401 6.68049C20.1539 6.48102 20.2625 6.3766 20.396 6.31383C20.7708 6.13758 20.9318 5.69082 20.7555 5.31598C20.5793 4.94114 20.1325 4.78016 19.7577 4.95641C19.2612 5.18984 18.9508 5.56265 18.7371 5.93746C18.5664 6.23681 18.4365 6.57953 18.3285 6.86447L18.3278 6.86634C18.3097 6.91412 18.2922 6.96027 18.2752 7.00431C18.0181 7.67155 17.7865 8.12487 17.2206 8.39095C16.9648 8.51125 16.6266 8.50272 16.0876 8.25943C15.584 8.03214 15.0478 7.66675 14.4276 7.24409L14.4275 7.24408L14.2647 7.1332C13.6097 6.68769 12.8631 6.19136 12.0941 5.89956C11.3058 5.60039 10.41 5.48423 9.51164 5.90664C8.59705 6.3367 8.11787 7.15114 7.85322 7.98582C7.59183 8.81021 7.50602 9.75857 7.44786 10.6099C7.43682 10.7715 7.42677 10.9291 7.41698 11.0825V11.0825C7.37265 11.7772 7.33375 12.3867 7.23371 12.8966C7.10484 13.5536 6.92809 13.7354 6.82467 13.7841C6.46013 13.9555 6.20084 13.9941 5.99759 13.9905C5.77823 13.9866 5.57999 13.9349 5.28861 13.8527L5.25775 13.8439L5.25774 13.8439C4.98765 13.7675 4.62798 13.6658 4.2113 13.6554C3.76014 13.6442 3.27972 13.7381 2.73537 13.994C1.55463 14.5492 0.947478 15.7511 0.635496 16.6477C0.472599 17.1159 0.372769 17.5512 0.313451 17.8685C0.283641 18.0279 0.263679 18.1595 0.250985 18.2532C0.244632 18.3001 0.240079 18.3376 0.237013 18.3645L0.233482 18.3967L0.232475 18.4065L0.232149 18.4099L0.232028 18.4111L0.231978 18.4116C0.231956 18.4118 0.231935 18.4121 0.940773 18.4795L0.231935 18.4121C0.192728 18.8244 0.495223 19.1905 0.907577 19.2297C1.3198 19.2689 1.68577 18.9666 1.72516 18.5544L1.7252 18.5541L1.72538 18.5524L1.72733 18.5346C1.72928 18.5176 1.73253 18.4905 1.7374 18.4547C1.74714 18.3828 1.76323 18.2761 1.78789 18.1442C1.83753 17.8788 1.92033 17.5196 2.05219 17.1407C2.32972 16.343 2.76054 15.6397 3.37365 15.3514C3.72623 15.1857 3.97644 15.1501 4.17397 15.155C4.38988 15.1603 4.58535 15.2128 4.88117 15.2963L4.89816 15.3011C5.12046 15.3638 5.4019 15.4433 5.72777 15.4758C5.80633 15.4837 5.88747 15.4888 5.97098 15.4903C6.42592 15.4983 6.91155 15.4008 7.46296 15.1415Z'
			fill='#33A867'
		/>
	</svg>
);
const DepositDonutChart = ({ data }: any) => {
	const { t } = useTranslation();
	const totalBuy = data?.find((item: any) => item.id === 'Deposit')?.value ?? 0;
	const totalSell = data?.find((item: any) => item.id === 'Withdraw')?.value ?? 0;
	const isBuyHigher = totalBuy > totalSell;

	return (
		<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around' }}>
			{/* Container for the donut */}
			<div style={{ height: '90px', width: '90px', position: 'relative' }}>
				<ResponsivePie
					data={data}
					startAngle={-80}
					innerRadius={0.9} // Thin the donut
					enableArcLabels={false}
					enableArcLinkLabels={false}
					isInteractive={false}
					colors={['#33a867', 'transparent']} // Green for active part, light gray for rest
					layers={[
						'arcs',
						// Custom layer for icon inside donut
						({ centerX, centerY }) => (
							<>
								<circle cx={centerX} cy={centerY} r={40} fill='#c3e6d3' />
								<circle
									cx={centerX}
									cy={centerY}
									r={20}
									fill='white'
									style={{ filter: 'drop-shadow(0px 0px 5px rgba(0,0,0,0.1))' }} // Light shadow for effect
								/>
								<g
									transform={`rotate(${isBuyHigher ? 0 : 90}, ${centerX}, ${centerY})`} // Rotate based on which value is higher
								>
									<SvgIcon centerX={centerX} centerY={centerY} />
								</g>
							</>
						),
					]}
				/>
			</div>

			{/* Container for text */}
			<div style={{ marginLeft: '10px', textAlign: 'left' }}>
				<div className='xss:text-[14px] md:text-[18px] font-bold text-[#333]'>{data[0].value ?? 0}%</div>
				<div className='xss:text-[13px] md:text-[16px]  text-[#33a867]'>{t('deposit')}</div>
			</div>
		</div>
	);
};

export default DepositDonutChart;
